import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Test } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface TestsState {
  tests: Test[];
}

// Define the initial state using that type
const initialState: TestsState = {
  tests: [],
};

export const testsSlice = createSlice({
  name: "tests",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setGlobalTests: (state, action: PayloadAction<Test[]>) => {
      state.tests = action.payload;
    },
  },
});

export const { setGlobalTests } = testsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getTests = (state: RootState) => state.tests;
export default testsSlice.reducer;
